/**
 * @module ui/native-app-cta-modal
 */
import cookies from "js-cookie";
import { configureModal, hideAllModals } from "ui/modal-manager";
import { NATIVE_APP_CTA_MODAL } from "ui/templates/modals/native-app-cta";
import { isIOS, isAndroid } from "utils/detect";
import { getById } from "utils/utils";
import logger from "utils/logger";

const debugTag = "[NATIVE-APP-CTA-MODAL]";

/**
 * Display a dismissable "download our native app" call to action (CTA) modal
 * dialog if the user has just finished subscribing and verifying their email
 * address and a Keytar wall is not currently being shown (subscribers shouldn't
 * see any subscription paywalls, but they may still see a
 * Globe Advisor wall, and having multiple, layered modals would be bad UX)
 */
export default function init() {
  logger.info(`${debugTag} Init`);

  const isSupportedPlatform = isIOS() || isAndroid();
  // Using indexOf() instead of cookies.get() in case cookie has no value assigned
  const cookieExists = document.cookie.indexOf("confirmedEmail") !== -1;
  const keytarWallExists = window.keytar !== undefined;

  if (isSupportedPlatform && cookieExists && !keytarWallExists) {
    logger.info(`${debugTag} Show modal`);

    const showModal = configureModal({
      uid: "native-app-cta-modal",
      templates: [NATIVE_APP_CTA_MODAL],
      width: "350",
      height: "500"
    });
    showModal();

    const closeButton = getById("js-native-app-cta-modal-close");
    closeButton && closeButton.addEventListener("click", () => {
      logger.info(`${debugTag} Close modal`);
      hideAllModals();
    });
  }
  if (cookieExists) {
    cookies.remove("confirmedEmail", { path: "/", domain: ".theglobeandmail.com" });
  }
}
